import React, { useEffect, useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useAuth, useProtectedContent, usePageList } from '../../../../context/AuthContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

const SystemDropdown = (props) => {
    const auth = useAuth()
    const showScheduledJobs = useProtectedContent(auth.permissions, 'system')
    let { pageList, setPageList } = usePageList()
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => {
        setDropdownOpen(!dropdownOpen)
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle tag="a" onClick={toggle} data-toggle="dropdown" aria-expanded={dropdownOpen} className="nav-link dropdown-toggle dropdown-toggle-blue dropdown-toggle-right">
                System
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-dark">
                {/* <Link className="dropdown-item" to="/system/settings" onClick={toggle}>
                    Server Settings
                </Link>                
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/mail" onClick={toggle}>
                    Mail
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" /> */}
                <Link className="dropdown-item" to="/system/mbStatus" onClick={toggle}>
                    MB Status
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/jobs" onClick={toggle}>
                    System Jobs
                </Link>
                {/* <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/settings-summary" onClick={toggle}>
                </Link> */}
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/jobHistory" onClick={toggle}>
                    System Jobs Log
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/dbJobHistory" onClick={toggle}>
                    DB Jobs Log
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/system/api-logs" onClick={toggle}>
                    Node Error Logs
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    alert(pageList.map(item => `${item.protected_content_name} [${item.type}]`).join('\n'))

                }}>
                    <FontAwesomeIcon icon={faEye} size={"1x"} /> Inspect Permissions
                </Link>
            </DropdownMenu>
        </Dropdown>
    )
}

export default SystemDropdown
